const containerTransportOrderDetails = {
	"container.transport.container.orderDetails.port": "Terminal"
};

export { containerTransportOrderDetails };
